import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { PATHS } from 'util/appConstants';
import { addZipcodes } from 'redux/slices/zipcodeSlice';
import { getTours, selectTours, selectTourStatus } from 'redux/slices/tourSlice';
import { getSuppliers, selectSuppliers, selectSuppliersStatus } from 'redux/slices/supplierSlice';
import ZipcodesForm from 'components/Zipcodes/form';
import Navbar from 'components/Navbar';
import CustomersNavbar from 'components/Masterbar/CustomersBar';
import LightLayout from 'components/Shared/LightLayout';
import {useTranslation} from "react-i18next";

const currentAction = "ADD";
const ZipcodeAdd = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectTourStatus);
  const suppliersLoading = useSelector(selectSuppliersStatus);
  const tours = useSelector(selectTours);
  const suppliers = useSelector(selectSuppliers);

  useEffect(() => {
    if (!tours.length && !loading) {
      dispatch(getTours());
    }
  }, [dispatch, tours, loading]);

  useEffect(() => {
    if (!suppliers.length && !suppliersLoading) {
      dispatch(getSuppliers());
    }
  }, [dispatch, suppliers, suppliersLoading]);

  const onSubmit = async (payload) => {
    await dispatch(addZipcodes(payload, t));
    history.push(PATHS.zipcodes.root);
  };

  return (
    <>
      <Navbar />
      <CustomersNavbar />
      <LightLayout doublebar>
        <ZipcodesForm
          action={currentAction}
          onSubmit={onSubmit}
          tourList={tours}
          supplierList={suppliers}
        />
      </LightLayout>
    </>
  );
};

export default ZipcodeAdd;
